import { EmptyScreen } from './EmptyScreen'
import { connect } from 'react-redux'

const mapStateToProps = state => ({ settingsPages: state.settingsPages })

export default connect(mapStateToProps)(EmptyScreen)
